import { render, staticRenderFns } from "./Reach.vue?vue&type=template&id=87e2e44e&scoped=true&"
import script from "./Reach.vue?vue&type=script&lang=js&"
export * from "./Reach.vue?vue&type=script&lang=js&"
import style0 from "./Reach.vue?vue&type=style&index=0&id=87e2e44e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e2e44e",
  null
  
)

export default component.exports